import React from "react";
export const BreadCrumbsContainer = ({ breadcrumbs, className = "" }) => {
    return (React.createElement("div", { id: "breadcrumb-container", className: "resources__breadcrumb-container filter-breadcrumb-container flex flex-wrap items-baseline " + className }, breadcrumbs));
};
